// extracted by mini-css-extract-plugin
export default {"iconButton":"icon-button_iconButton__j4X5r"};